import {Model, View} from "@lernetz/ts-lib";
import template from "./related-content.component.html";

export class RelatedContentView extends View {
    constructor() {
        super({ template });
    }
}

export class RelatedContent extends Model {
    constructor(dto) {
        super(dto);
    }
}
